
const hmc_self_category_avg =
    {
     '윤리':78.1,
     '환경':69.5,
     '노동/인권':75.4,
     '안전/보건':72.1 
    }
const hmc_self_total_avg = 73.1

const hmc_self_category_max =
    {
     '윤리':100,
     '환경':100,
     '노동/인권':96.8,
     '안전/보건':97.1 
    }

const hmc_self_total_max = 99


const hmc_category_avg =
    {
     '윤리':56.7,
     '환경':64.9,
     '노동/인권':69.7,
     '안전/보건':81.2 
    }
const hmc_total_avg = 65.6

const hmc_category_max =
    {
     '윤리':100,
     '환경':93,
     '노동/인권':90.5,
     '안전/보건':100
    }

const hmc_total_max = 91.1

export { hmc_self_category_avg, hmc_self_total_avg, hmc_self_category_max, hmc_self_total_max, hmc_category_avg, hmc_total_avg, hmc_category_max, hmc_total_max }